import { RatingScalePresentation } from '@core/candidate-evaluation-settings-types';

import { getRatingIconIndex } from './get-rating-icon-index';
import { RatingThumbOption, THUMBS_4_OPTIONS, THUMBS_5_OPTIONS } from './rating-thumb.config';

export const getRatingThumb = (
  percent: number,
  presentation: RatingScalePresentation,
): RatingThumbOption => {
  const options =
    presentation === RatingScalePresentation.Thumbs4 ? THUMBS_4_OPTIONS : THUMBS_5_OPTIONS;
  return options[getRatingIconIndex(percent, options.length)];
};
